import { render } from "./NormalTable.vue?vue&type=template&id=258e434c"
import script from "./NormalTable.vue?vue&type=script&lang=js"
export * from "./NormalTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zhi_ai_pc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__